import { render, staticRenderFns } from "./StationAddressScreen.vue?vue&type=template&id=dc904ac0"
import script from "./StationAddressScreen.vue?vue&type=script&lang=js"
export * from "./StationAddressScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports